import { Controller } from "stimulus";

export default class extends Controller {
  static targets = ["select"];

  showModal(event) {
    event.preventDefault();

    const modal = document.getElementById("quick-add-category-modal");
    if (modal) {
      $(modal).modal("show");
      // Store reference to the select element
      modal.dataset.targetSelect = this.selectTarget.id;
    } else {
      // Create modal if it doesn't exist
      this.createModal();
    }
  }

  createModal() {
    const modalHTML = `
      <div class="modal fade" id="quick-add-category-modal" tabindex="-1" role="dialog">
        <div class="modal-dialog" role="document">
          <div class="modal-content">
            <div class="modal-header">
              <button type="button" class="close" data-dismiss="modal" aria-label="Close">
                <span aria-hidden="true">&times;</span>
              </button>
              <h4 class="modal-title">
                <i class="glyphicon glyphicon-folder-open"></i> Create New Category
              </h4>
            </div>
            <div class="modal-body">
              <form id="quick-category-form">
                <div class="form-group">
                  <label for="category-name" class="control-label">Category Name *</label>
                  <input type="text" 
                         id="category-name" 
                         class="form-control" 
                         placeholder="e.g., Preparation, Procedure, Post-Procedure"
                         required>
                  <p class="help-block">Choose a clear, descriptive name for this phase of the procedure.</p>
                </div>
                
                <div class="form-group">
                  <label for="category-description" class="control-label">Description (Optional)</label>
                  <textarea id="category-description" 
                            class="form-control" 
                            rows="2"
                            placeholder="Brief description of this phase"></textarea>
                </div>
                
                <div id="category-error" class="alert alert-danger" style="display: none;"></div>
                <div id="category-success" class="alert alert-success" style="display: none;"></div>
              </form>
            </div>
            <div class="modal-footer">
              <button type="button" class="btn btn-default" data-dismiss="modal">Cancel</button>
              <button type="button" 
                      class="btn btn-success" 
                      onclick="window.categoryQuickAdd.saveCategory()">
                <i class="glyphicon glyphicon-ok"></i> Create Category
              </button>
            </div>
          </div>
        </div>
      </div>
    `;

    document.body.insertAdjacentHTML("beforeend", modalHTML);
    const modal = document.getElementById("quick-add-category-modal");
    modal.dataset.targetSelect = this.selectTarget.id;
    $(modal).modal("show");

    // Set up global reference for modal actions
    window.categoryQuickAdd = {
      saveCategory: () => this.saveCategory(),
    };
  }

  async saveCategory() {
    const nameInput = document.getElementById("category-name");
    const descriptionInput = document.getElementById("category-description");
    const errorDiv = document.getElementById("category-error");
    const successDiv = document.getElementById("category-success");

    const name = nameInput.value.trim();

    if (!name) {
      this.showError("Category name is required");
      return;
    }

    // Hide previous messages
    errorDiv.style.display = "none";
    successDiv.style.display = "none";

    try {
      const response = await fetch("/checklist_categories", {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
          "X-CSRF-Token": document.querySelector('meta[name="csrf-token"]')
            .content,
        },
        body: JSON.stringify({
          checklist_category: {
            name: name,
            description: descriptionInput.value.trim(),
          },
        }),
      });

      if (response.ok) {
        const data = await response.json();
        this.showSuccess(`Category "${name}" created successfully!`);

        // Add new option to all category selects on the page
        this.addCategoryToSelects(data.id, data.name);

        // Clear form
        nameInput.value = "";
        descriptionInput.value = "";

        // Close modal after short delay
        setTimeout(() => {
          $("#quick-add-category-modal").modal("hide");
          successDiv.style.display = "none";
        }, 1500);
      } else {
        const data = await response.json();
        this.showError(data.error || "Failed to create category");
      }
    } catch (error) {
      console.error("Error creating category:", error);
      this.showError("An error occurred. Please try again.");
    }
  }

  addCategoryToSelects(id, name) {
    // Find all category selects on the page and add the new option
    const selects = document.querySelectorAll(
      'select[name*="[checklist_category_id]"]'
    );
    selects.forEach((select) => {
      const option = new Option(name, id, false, true);
      select.add(option);

      // If this is the select that triggered the modal, select the new option
      const modal = document.getElementById("quick-add-category-modal");
      if (modal && select.id === modal.dataset.targetSelect) {
        select.value = id;
        // Trigger change event for any listeners
        select.dispatchEvent(new Event("change"));
      }
    });
  }

  showError(message) {
    const errorDiv = document.getElementById("category-error");
    errorDiv.textContent = message;
    errorDiv.style.display = "block";
  }

  showSuccess(message) {
    const successDiv = document.getElementById("category-success");
    successDiv.innerHTML = `<i class="glyphicon glyphicon-ok"></i> ${message}`;
    successDiv.style.display = "block";
  }
}

